export default __webpack_public_path__ + "static/pic06-b2b3d6bc2a048e020ad99341c17c0d62.jpg";